"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _BottomExtraSpace = require("./BottomExtraSpace");

var _BottomExtraSpace2 = _interopRequireDefault(_BottomExtraSpace);

var _NoSsr = require("@material-ui/core/NoSsr");

var _NoSsr2 = _interopRequireDefault(_NoSsr);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

exports["default"] = function (props) {
  return _react2["default"].createElement(_react.Fragment, null, _react2["default"].createElement("div", {
    className: "fixed bottom-0 left-0 w-100 z-999"
  }, props.children), _react2["default"].createElement(_NoSsr2["default"], null, _react2["default"].createElement(_BottomExtraSpace2["default"], null, props.children)));
};